import { WalletAddressesSaved } from 'BreetComponents';
import { useUsdWithdrawRequestContext } from 'BreetHooks';
import { useCallback } from 'react';

const DialogWithdrawUsdWalletAddressesSaved = () => {
	const { handleSelectAddress, resetWalletAddressProps, formDataContextProps, formStage } = useUsdWithdrawRequestContext();

	const onAddNewAddress = useCallback(() => {
		resetWalletAddressProps();
		formStage.navigator.goTo('add-wallet-address')();
	}, [resetWalletAddressProps, formStage]);

	const formData = formDataContextProps.hookFormProps.watch();

	return (
		<WalletAddressesSaved
			onAddNewAddress={onAddNewAddress}
			onSelectAddress={handleSelectAddress}
			onManageAddress={formStage.navigator.goTo('manage-wallet-address')}
			selectedWalletAddress={formData.receiverAddress}
			onButtonClick={formStage.navigator.goTo('crypto-transaction-details')}
			isButtonDisabled={!formDataContextProps.isFormCompleted}
		/>
	);
};

export default DialogWithdrawUsdWalletAddressesSaved;
